import React, { Component } from "react";
import { connect } from "react-redux";
import withAuth from "../../components/withAuth";
import { Helmet } from "react-helmet";

// LIBS
import { loggedIn } from "../../api/jwt";
import { fetchMyUserIfNeeded } from "../../actions/MyUserActions";

// UI
import {
  BiletsCountTypes,
  LoginList,
  MaterialBase
  // MissingEmail
} from "./widgets";
import { HeaderPage, Container, Row, Col } from "../../ui";

class DashboardPage extends Component {
  state = {
    titleHeader: "Управление ломбардом"
  };

  componentDidMount() {
    if (loggedIn()) {
      const { dispatch, user } = this.props;
      dispatch(fetchMyUserIfNeeded(user));
    }
  }

  render() {
    // const user = this.props.myUser || {};

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        {/* Показываем уведомленние что необходимо заполнить email */}
        {/* <MissingEmail user={user} /> */}

        <Container fluid padding="no">
          <HeaderPage title="Панель управления" />

          <Row>
            {/*
            <Col lg={12} md={12} sm={12} xs={12}>
              <P>
                Деньги в кассе (на начало дня, приход, расход, сейчас) + ИТОГО
              </P>
              <P>Доход за сегодня</P>
              <P>График по филиалам по доходности</P>
              <P>График по филиалам по материальной базе</P>
              <P>Общий график: Приход/Расход (по свем филиалам за год)</P>
              <P>
                Активность филиалов: Общая прибыль (по всем филиалам, за
                последние 3 месяца)
              </P>
              <P>
                Активность пользователей: Общая прибыль (по каждому
                пользователю, за каждый из последних 3 месяцев)
              </P>
              <P>Рентабельность билетов</P>
            </Col>
                */}

            <Col lg={6} md={6} sm={12} xs={12} padding="no">
              {/* Показываем количество билетов по категориям (заканчиваются сегодня, на льготе, просроченные) */}
              <BiletsCountTypes />
              {/* Показываем материальную базу */}
              <MaterialBase />
            </Col>

            <Col lg={6} md={6} sm={12} xs={12}>
              {/* Показываем список сходов пользователей */}
              <LoginList />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  myUser: state.user
});

export default withAuth(connect(mapStateToProps)(DashboardPage));
